import KitPackageElement, { PackageElement } from "./KitPackageElement";


interface Props {
  availablePackageElements: PackageElement[];
  selectedPackageElements: PackageElement[];
  onPackageElementQuantityChanged: (packageElement: PackageElement, quantity: number) => void;
}

const KitPackageElementSection = (props: Props) => {

  const findSelectedPackageElement = (packageElementId: number) =>
    props.selectedPackageElements.find(packageElement => packageElement.id === packageElementId);

  const renderPackageElement = (availablePackageElement: PackageElement) =>
    <KitPackageElement
      availablePackageElement={ availablePackageElement }
      selectedPackageElement={ findSelectedPackageElement(availablePackageElement.id) }
      onPackageElementQuantityChanged={ props.onPackageElementQuantityChanged }
    />;

  return <>{
    props.availablePackageElements.map(renderPackageElement)
  }</>
};

export default KitPackageElementSection;